import {
  FocusableContext
} from "./BMLNRUFQ.js";
import {
  createComponent,
  createElement,
  createHook
} from "./CFEUKV6C.js";
import {
  useWrapElement
} from "./J7Q2EO23.js";
import {
  __objRest
} from "./PNRLI7OV.js";

// src/focusable/focusable-container.tsx
import { jsx } from "react/jsx-runtime";
var useFocusableContainer = createHook(
  (_a) => {
    var _b = _a, { autoFocusOnShow = true } = _b, props = __objRest(_b, ["autoFocusOnShow"]);
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(FocusableContext.Provider, { value: autoFocusOnShow, children: element }),
      [autoFocusOnShow]
    );
    return props;
  }
);
var FocusableContainer = createComponent(
  (props) => {
    const htmlProps = useFocusableContainer(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  FocusableContainer.displayName = "FocusableContainer";
}

export {
  useFocusableContainer,
  FocusableContainer
};
